import classNames from "classnames";
import React, { type FC } from "react";
import { Link } from "react-router-dom";
import type { MobileNavBarOption } from "./MobileNavBar";
import "./MobileNavButton.scss";

/** Пропсы кнопки нижней навигации. */
interface MobileNavButtonProps {
    className?: string;
    navOption: MobileNavBarOption;
}

/**
 * Кнопка пункта нижней навигации: `Link` или clickable div.
 */
export const MobileNavButton: FC<MobileNavButtonProps> = ({ className, navOption }) => {
    if (navOption.linkTo != null) {
        return (
            <Link
                className={classNames("mobile_nav_button", className)}
                to={navOption.linkTo}
                onClick={(event) => {
                    navOption.onClick?.();
                    event.currentTarget.blur();
                }}
            >
                <span className="mobile_nav_button__icon">{navOption.icon}</span>
                <div className="mobile_nav_button__text">{navOption.name}</div>
            </Link>
        );
    }

    return (
        <div className={classNames("mobile_nav_button", className)} onClick={navOption.onClick}>
            <span className="mobile_nav_button__icon">{navOption.icon}</span>
            <div className="mobile_nav_button__text">{navOption.name}</div>
        </div>
    );
};
